import React, { useEffect } from 'react'
import { Views } from '../../views'
import { connect } from 'react-redux'
import { GET_RESERVATION } from '../../redux/actions/type'
import moment from 'moment'
import { get } from 'lodash'
import { login } from '../../helpers'

const Reservation = ({
    language,
    reservationList,
    reservationItems,
    activeItem,
    getReservation,
    calendarDate,
    keycloak
}) => {
    const { ReservationView } = Views
    const startDate = Date.parse(moment().startOf('month').subtract(7, 'day').format('M/D/Y'));
    const endDate = Date.parse(moment().endOf('month').add(7, 'day').format('M/D/Y'));

    useEffect(() => {
        getReservation(
            startDate,
            endDate
        )
    }, [getReservation, startDate, endDate])

    if (keycloak.authenticated === false) {
        login(keycloak, language)
    }

    return (
        <ReservationView
            language={language}
            reservationList={reservationList}
            reservationItems={reservationItems}
            activeItem={activeItem}
            calendarDate={calendarDate}
        />
    )
}

const mapStateToProps = state => ({
    language: state.language,
    reservationList: get(state, 'reservation.reservationList', []),
    reservationItems: get(state, 'reservation.reservationItems', []),
    activeItem: get(state, 'reservation.activeItem', 0),
    calendarDate: state.reservation.calendarDate,
    keycloak: get(state, "keycloak", "")
})

const mapDispatchToProps = dispatch => ({
    getReservation: (startDate, endDate) => {
        dispatch({
            type: GET_RESERVATION,
            payload: {
                startDate,
                endDate
            }
        })
    }
})

export default connect(mapStateToProps, mapDispatchToProps)(Reservation)